export default __webpack_public_path__ + "static/media/ba-spanish-literature.8f65a0fd.pdf";